import React from 'react';
import { ControlledComponent } from '@aha-app/mvc';
import ControlledAssistantView from '../AssistantView/ControlledAssistantView';
import AssistantViewController from '../AssistantView/AssistantViewController';
import HeaderButtons from '../HeaderPanel/HeaderButtons';
import { type SidePanelItem } from 'javascripts/shared-types';

const assistantSidePanelConfiguration = ({
  agentName,
  agentParams,
  agentInstances,
  alwaysRendered = false,
}): SidePanelItem | null => {
  if (!window.currentAccount?.hasGeneralAiAssistant) {
    return null;
  }
  // Initialize the controller directly so we can pass it to both the title and
  // the content.
  const controller = new AssistantViewController();
  controller.internalInitialize(null, {
    agentName,
    agentParams,
    agentInstances,
    dock: 'side-panel',
  });

  // TODO: How does the controller get destroyed so we can clean up any network requests.

  // TODO: Ideally this would only load dynamically when first used. We need
  // the ability to return an async function that loads the code when first rendered.

  return {
    id: 'assistant',
    name: 'AI assistant',
    icon: <aha-ai-icon />,
    alwaysRendered,
    titleContent: (
      <ControlledComponent controller={controller}>
        <HeaderButtons />
      </ControlledComponent>
    ),
    tabContent: (
      <aha-sidepanel-item>
        <aha-ai-icon />
      </aha-sidepanel-item>
    ),
    content: (
      <ControlledComponent controller={controller}>
        <ControlledAssistantView />
      </ControlledComponent>
    ),
  };
};

export default assistantSidePanelConfiguration;
